export default __webpack_public_path__ + "static/media/hiking.18fffc02.png";